import React from 'react';
import { useClickOutside, round_to } from '../utils';
import { default as Styles, colors } from '../styles';
const Tooltip = ({ msg, show = false, onClick }) => {
  const ref = useClickOutside(() => (show ? onClick() : {}));

  if (!msg) return null;

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="border-radius"
      style={{
        ...Styles.pinned,
        backgroundColor: colors.chart_tips,
        borderRadius: '6px',
        color: colors.purple,
        cursor: 'pointer',
        opacity: show ? 1 : 0,
        padding: '20px',
      }}
      animate={show ? 'visible' : 'hidden'}
      onClick={onClick}
    >
      <p style={{ ...Styles.uppercase }}>
        <span>{msg.label}</span>{' '}
        {msg.percent
          ? ` ${round_to(msg.percent * 100, 0)}%`
          : msg.value || msg.raw}
      </p>
    </div>
  );
};
export default Tooltip;
